(function() {

  var path = window.location.pathname.replace(/\/$/, "");
  var redirects = {
    // Packs aventurier
    "/products/pack-aventurier-3-ans": "/pages/pack-aventurier",
    "/products/mon-pack-aventurier-5-ans": "/pages/pack-aventurier",

    // Packs explorateur
    "/products/pack-explorateur-buga-cartes-5-ans": "/pages/pack-explorateur",
    "/products/pack-explorateur-buga-cartes-3-ans": "/pages/pack-explorateur",
    "/products/pack-explorateur-buga-livres-5-ans": "/pages/pack-explorateur",
    "/products/pack-explorateur-buga-livres-3-ans": "/pages/pack-explorateur",

    // Packs découverte
    "/products/pack-decouverte-buga-cartes-5-ans": "/pages/pack-decouverte",
    "/products/pack-decouverte-buga-cartes-3-ans": "/pages/pack-decouverte",
    "/products/pack-decouverte-buga-livres-5-ans": "/pages/pack-decouverte",
    "/products/pack-decouverte-livres-3-ans": "/pages/pack-decouverte"
  };

  if (redirects[path]) {
    window.location.replace(redirects[path]);
  }
})();
